<template>
	<div class="risk_radio">
		<div v-for="(item,index) in options" :key="index" class="risk_radio-margin-item">
			<van-field
				class="risk_radio-input-item "
				type="number"
				:border="false"
				v-if="item.type==='input'"
				v-model="inputValue"
				:placeholder="item.placeholder"
			>
				<template #right-icon>
					{{item.rightText}}
				</template>
			</van-field>
			<div
				v-else
				@click="onClick(item)"
				class="risk_radio-item"
				:class="value === item.value ?'risk_radio-select':''"
			>
				{{item.label}}
			</div>
		</div>
	</div>
</template>
<script>
export default {
    props: {
        options: {
            type: Array,
            default: () => []
        },
        value: {
            type: [String, Number],
            default: ''
        }
    },
    computed: {
        inputValue: {
            get () {
                return this.options.filter(v => v.type != 'input').map(v => v.value).indexOf(this.value) > -1 ? '' : this.value
            },
            set (val) {
                let rule = this.options[0].rule
                if (rule) {
                    this.$emit('input', '')
                    if (val > rule.max) {
                        this.$toast('血压最大值为250')
                        return
                    }
                    if (val < rule.min) {
                        this.$toast('血压最小值为90')
                        return
                    }
                }
                this.$emit('input', val)
                this.options[0].value = val
            }
        }
    },
    methods: {
        onClick (val) {
            console.log(val)
            this.$emit('input', val.value)
        }
    }
}
</script>
<style lang="less" scoped>
.risk_radio {
	&-item {
		height: 120px;
		border-radius: 16px;
		border: 1px solid #f7f7f7;
		background: #f7f7f7;
		font-size: 30px;
		line-height: 120px;
		padding: 0 32px;
	}
	&-input-item {
		height: 120px;
		border-radius: 16px;
		border: 1px solid #f7f7f7;
		background: #f7f7f7;
		font-size: 30px;
		line-height: 120px;
		padding: 0 32px;
	}
	&-margin-item {
		margin-bottom: 26px;
	}
	&-margin-item:last-of-type {
		margin-bottom: 0;
	}
	&-select {
		border: 1px solid rgba(21, 197, 206, 0.5);
		background: rgba(21, 197, 206, 0.06);
		color: @primary;
	}
}
</style>